import { render, staticRenderFns } from "./myFollow.vue?vue&type=template&id=2f41cc64&scoped=true&"
import script from "./myFollow.vue?vue&type=script&lang=js&"
export * from "./myFollow.vue?vue&type=script&lang=js&"
import style0 from "./myFollow.vue?vue&type=style&index=0&id=2f41cc64&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./myFollow.vue?vue&type=style&index=1&id=2f41cc64&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41cc64",
  null
  
)

export default component.exports